import { render, staticRenderFns } from "./AppNavbarVerticalLayout.vue?vue&type=template&id=4e8f4b06&scoped=true"
import script from "./AppNavbarVerticalLayout.vue?vue&type=script&lang=js"
export * from "./AppNavbarVerticalLayout.vue?vue&type=script&lang=js"
import style0 from "./AppNavbarVerticalLayout.vue?vue&type=style&index=0&id=4e8f4b06&prod&lang=scss"
import style1 from "./AppNavbarVerticalLayout.vue?vue&type=style&index=1&id=4e8f4b06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8f4b06",
  null
  
)

export default component.exports